export default __webpack_public_path__ + "static/media/AfnFashion.9508e755.jpg";